/**
 * BillingWalletApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ClientWalletTransaction } from '../model/clientWalletTransaction';
import { ClientWalletTransactionDto } from '../model/clientWalletTransactionDto';
import { ClientWalletTransactionPaginatedResult } from '../model/clientWalletTransactionPaginatedResult';
import { ProblemDetails } from '../model/problemDetails';
import { Reason } from '../model/reason';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ClientWalletTransactionService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param clientWalletId 
     * @param startDate 
     * @param endDate 
     * @param page 
     * @param pageSize 
     * @param reason 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientWalletTransactionGet(clientWalletId?: string, startDate?: Date, endDate?: Date, page?: number, pageSize?: number, reason?: Reason, observe?: 'body', reportProgress?: boolean): Observable<ClientWalletTransactionPaginatedResult>;
    public apiClientWalletTransactionGet(clientWalletId?: string, startDate?: Date, endDate?: Date, page?: number, pageSize?: number, reason?: Reason, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientWalletTransactionPaginatedResult>>;
    public apiClientWalletTransactionGet(clientWalletId?: string, startDate?: Date, endDate?: Date, page?: number, pageSize?: number, reason?: Reason, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientWalletTransactionPaginatedResult>>;
    public apiClientWalletTransactionGet(clientWalletId?: string, startDate?: Date, endDate?: Date, page?: number, pageSize?: number, reason?: Reason, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientWalletId !== undefined && clientWalletId !== null) {
            queryParameters = queryParameters.set('clientWalletId', <any>clientWalletId);
        }
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('pageSize', <any>pageSize);
        }
        if (reason !== undefined && reason !== null) {
            queryParameters = queryParameters.set('reason', <any>reason);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientWalletTransactionPaginatedResult>('get',`${this.basePath}/api/ClientWalletTransaction`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientAuthId 
     * @param merchantAuthId 
     * @param reason 
     * @param page 
     * @param pageSize 
     * @param startDate 
     * @param endDate 
     * @param sortBy 
     * @param isAscending 
     * @param draw 
     * @param search 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientWalletTransactionGetByClientAuthIdAndMerchantAuthIdGet(clientAuthId?: string, merchantAuthId?: string, reason?: Reason, page?: number, pageSize?: number, startDate?: Date, endDate?: Date, sortBy?: string, isAscending?: boolean, draw?: number, search?: string, observe?: 'body', reportProgress?: boolean): Observable<ClientWalletTransactionPaginatedResult>;
    public apiClientWalletTransactionGetByClientAuthIdAndMerchantAuthIdGet(clientAuthId?: string, merchantAuthId?: string, reason?: Reason, page?: number, pageSize?: number, startDate?: Date, endDate?: Date, sortBy?: string, isAscending?: boolean, draw?: number, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientWalletTransactionPaginatedResult>>;
    public apiClientWalletTransactionGetByClientAuthIdAndMerchantAuthIdGet(clientAuthId?: string, merchantAuthId?: string, reason?: Reason, page?: number, pageSize?: number, startDate?: Date, endDate?: Date, sortBy?: string, isAscending?: boolean, draw?: number, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientWalletTransactionPaginatedResult>>;
    public apiClientWalletTransactionGetByClientAuthIdAndMerchantAuthIdGet(clientAuthId?: string, merchantAuthId?: string, reason?: Reason, page?: number, pageSize?: number, startDate?: Date, endDate?: Date, sortBy?: string, isAscending?: boolean, draw?: number, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {












        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientAuthId !== undefined && clientAuthId !== null) {
            queryParameters = queryParameters.set('ClientAuthId', <any>clientAuthId);
        }
        if (merchantAuthId !== undefined && merchantAuthId !== null) {
            queryParameters = queryParameters.set('MerchantAuthId', <any>merchantAuthId);
        }
        if (reason !== undefined && reason !== null) {
            queryParameters = queryParameters.set('Reason', <any>reason);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('Page', <any>page);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('StartDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('EndDate', <any>endDate.toISOString());
        }
        if (sortBy !== undefined && sortBy !== null) {
            queryParameters = queryParameters.set('SortBy', <any>sortBy);
        }
        if (isAscending !== undefined && isAscending !== null) {
            queryParameters = queryParameters.set('IsAscending', <any>isAscending);
        }
        if (draw !== undefined && draw !== null) {
            queryParameters = queryParameters.set('Draw', <any>draw);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientWalletTransactionPaginatedResult>('get',`${this.basePath}/api/ClientWalletTransaction/GetByClientAuthIdAndMerchantAuthId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientAuthId 
     * @param startDate 
     * @param endDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientWalletTransactionGetByClientAuthIdClientAuthIdGet(clientAuthId: string, startDate?: Date, endDate?: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<ClientWalletTransaction>>;
    public apiClientWalletTransactionGetByClientAuthIdClientAuthIdGet(clientAuthId: string, startDate?: Date, endDate?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientWalletTransaction>>>;
    public apiClientWalletTransactionGetByClientAuthIdClientAuthIdGet(clientAuthId: string, startDate?: Date, endDate?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientWalletTransaction>>>;
    public apiClientWalletTransactionGetByClientAuthIdClientAuthIdGet(clientAuthId: string, startDate?: Date, endDate?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (clientAuthId === null || clientAuthId === undefined) {
            throw new Error('Required parameter clientAuthId was null or undefined when calling apiClientWalletTransactionGetByClientAuthIdClientAuthIdGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientWalletTransaction>>('get',`${this.basePath}/api/ClientWalletTransaction/GetByClientAuthId/${encodeURIComponent(String(clientAuthId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param merchantAuthId 
     * @param reason 
     * @param page 
     * @param pageSize 
     * @param startDate 
     * @param endDate 
     * @param sortBy 
     * @param isAscending 
     * @param draw 
     * @param search 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientWalletTransactionGetByMerchantAuthIdGet(merchantAuthId?: string, reason?: Reason, page?: number, pageSize?: number, startDate?: Date, endDate?: Date, sortBy?: string, isAscending?: boolean, draw?: number, search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ClientWalletTransactionDto>>;
    public apiClientWalletTransactionGetByMerchantAuthIdGet(merchantAuthId?: string, reason?: Reason, page?: number, pageSize?: number, startDate?: Date, endDate?: Date, sortBy?: string, isAscending?: boolean, draw?: number, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientWalletTransactionDto>>>;
    public apiClientWalletTransactionGetByMerchantAuthIdGet(merchantAuthId?: string, reason?: Reason, page?: number, pageSize?: number, startDate?: Date, endDate?: Date, sortBy?: string, isAscending?: boolean, draw?: number, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientWalletTransactionDto>>>;
    public apiClientWalletTransactionGetByMerchantAuthIdGet(merchantAuthId?: string, reason?: Reason, page?: number, pageSize?: number, startDate?: Date, endDate?: Date, sortBy?: string, isAscending?: boolean, draw?: number, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {











        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (merchantAuthId !== undefined && merchantAuthId !== null) {
            queryParameters = queryParameters.set('MerchantAuthId', <any>merchantAuthId);
        }
        if (reason !== undefined && reason !== null) {
            queryParameters = queryParameters.set('Reason', <any>reason);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('Page', <any>page);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('StartDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('EndDate', <any>endDate.toISOString());
        }
        if (sortBy !== undefined && sortBy !== null) {
            queryParameters = queryParameters.set('SortBy', <any>sortBy);
        }
        if (isAscending !== undefined && isAscending !== null) {
            queryParameters = queryParameters.set('IsAscending', <any>isAscending);
        }
        if (draw !== undefined && draw !== null) {
            queryParameters = queryParameters.set('Draw', <any>draw);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientWalletTransactionDto>>('get',`${this.basePath}/api/ClientWalletTransaction/GetByMerchantAuthId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientResourceId 
     * @param transactionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLastBalanceByTransactionId(clientResourceId: string, transactionId: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public getLastBalanceByTransactionId(clientResourceId: string, transactionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public getLastBalanceByTransactionId(clientResourceId: string, transactionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public getLastBalanceByTransactionId(clientResourceId: string, transactionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (clientResourceId === null || clientResourceId === undefined) {
            throw new Error('Required parameter clientResourceId was null or undefined when calling getLastBalanceByTransactionId.');
        }

        if (transactionId === null || transactionId === undefined) {
            throw new Error('Required parameter transactionId was null or undefined when calling getLastBalanceByTransactionId.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('get',`${this.basePath}/api/ClientWalletTransaction/${encodeURIComponent(String(clientResourceId))}/${encodeURIComponent(String(transactionId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
